import { useState } from 'react'
import { useAuthStore } from '../store/authStore'
import QRCode from 'qrcode'
import * as OTPAuth from 'otpauth'

export default function SettingsPage() {
  const { admin } = useAuthStore()
  const [qrCodeUrl, setQrCodeUrl] = useState('')
  const [showQR, setShowQR] = useState(false)

  const handleSetup2FA = async () => {
    const secret = new OTPAuth.Secret()
    const totp = new OTPAuth.TOTP({
      issuer: 'Waybook Admin',
      label: admin?.username || 'Admin',
      algorithm: 'SHA1',
      digits: 6,
      period: 30,
      secret: secret,
    })

    const uri = totp.toString()
    const qrCode = await QRCode.toDataURL(uri)
    setQrCodeUrl(qrCode)
    setShowQR(true)
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-1">Manage your admin account settings</p>
      </div>

      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Profile</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
            <input
              type="text"
              value={admin?.username || ''}
              className="input w-full max-w-md"
              disabled
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={admin?.email || ''}
              className="input w-full max-w-md"
              disabled
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
            <input
              type="text"
              value={admin?.role === 'super_admin' ? 'Super Admin' : 'Admin'}
              className="input w-full max-w-md"
              disabled
            />
          </div>
        </div>
      </div>

      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Two-Factor Authentication</h2>
        {admin?.twoFactorEnabled ? (
          <div className="flex items-center gap-3">
            <span className="badge badge-success">Enabled</span>
            <button className="btn-danger">Disable 2FA</button>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Two-factor authentication adds an extra layer of security to your account.
            </p>
            <button onClick={handleSetup2FA} className="btn-primary">
              Enable 2FA
            </button>

            {showQR && (
              <div className="mt-4 p-4 border rounded-lg">
                <p className="text-sm font-medium text-gray-900 mb-2">
                  Scan this QR code with your authenticator app:
                </p>
                <img src={qrCodeUrl} alt="QR Code" className="w-64 h-64" />
                <p className="text-sm text-gray-600 mt-2">
                  After scanning, enter the 6-digit code from your app to verify.
                </p>
                <div className="flex gap-2 mt-4">
                  <input
                    type="text"
                    placeholder="000000"
                    className="input w-32 text-center"
                    maxLength={6}
                  />
                  <button className="btn-primary">Verify</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Change Password</h2>
        <div className="space-y-4 max-w-md">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Current Password
            </label>
            <input type="password" className="input w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Password
            </label>
            <input type="password" className="input w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm New Password
            </label>
            <input type="password" className="input w-full" />
          </div>
          <button className="btn-primary">Update Password</button>
        </div>
      </div>
    </div>
  )
}
